import { MijnRoute } from '../../mijn-navigatie.model';

export const INVESTMENT_CANCEL_ACCOUNT: MijnRoute = {
    path: ':id/rekening-opheffen',
    navigationEvent: 'toBeleggenCancelAccount',
    regex: /^\/beleggen\/[^/]+\/rekening-opheffen$/,
    webcomponent: 'mijn-beleggen-portfolio-webcomponent',
    internalPath: ':id/rekening-opheffen'
};
